import i18n from "../plugins/vue-i18n";

const availableLanguages = [
  'en',
  'es',
  'it',
  'pt',
  'fr',
  'de',
  'pl',
  'ro',
  'eo',
  'ru'
];

export function createMapLangNameToCode(){
  const map = {};
  availableLanguages.forEach(langCode=>{
    map[i18n.t(`languages.${langCode}`)] = langCode;
  })
  return map;
}

export function createMapLangCodeToName(){
  const map = {};
  availableLanguages.forEach(langCode=>{
    map[langCode] = i18n.t(`languages.${langCode}`);
  })
  return map;
}

export const mapLangCodeToName = createMapLangCodeToName();
export const mapLangNameToCode = createMapLangNameToCode();

export function valid2LetterCode(code){
  return code && availableLanguages.includes(code);
}

export function getAvailableLocales(){
  return [
    {label: 'English', code: 'en'},
    {label: 'Español', code: 'es'},
    {label: 'Português', code: 'pt'},
    {label: 'Italiano', code: 'it'},
    {label: 'Français', code: 'fr'},
    {label: 'Deutsch', code: 'de'},
    {label: 'Polski', code: 'pl'},
    {label: 'Română', code: 'ro'},
    {label: 'Русский', code: 'ru'},
    {label: 'Esperanto', code: 'eo'},
  ];
}
